import { ICategory } from '@/models/categories.model';

export const categoriesOptions = (categories: ICategory[]): { id: string; name: string }[] => {
  return categories?.map(({ id, name }) => ({ id, name }));
};
